import React, { useEffect, useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import { selectJobProfile, updateJob } from '../../../../redux/modules/jobs';
import { getDateObject, getDateString } from '../../../../utils/dateUtil';
import Attachments from '../Attachments';

import JobInfoDisplay from './components/JobInfoDisplay';
import JobInfoForm from './components/JobInfoForm';
import JobInfoHeader from './components/JobInfoHeader';
import JobStats from './components/JobStats';
import { formInputNames } from './util';

const JobInfoPanel = () => {
  const dispatch = useDispatch();
  const jobProfile = useSelector(selectJobProfile);
  const [isEditing, setIsEditing] = useState(false);

  const useFormMethods = useForm({
    defaultValues: {
      [formInputNames.jobName]: jobProfile?.jobName,
      [formInputNames.jobNumber]: jobProfile?.jobNumber,
      [formInputNames.jobDescription]: jobProfile?.jobDescription,
      [formInputNames.jobStart]: getDateObject(jobProfile.jobStart, true),
      [formInputNames.jobEnd]: getDateObject(jobProfile.jobEnd, true),
      [formInputNames.status]: jobProfile?.status
    }
  });

  const { handleSubmit, control } = useFormMethods;
  const { isDirty } = useFormState({ control });

  const renderDisplayOrForm = () => {
    if (isEditing) return (<JobInfoForm isEditing={isEditing} useFormMethods={useFormMethods} />);

    return (<JobInfoDisplay />);
  };

  const onSubmit = data => {
    if (isEditing) {
      const updatedData = {
        ...data,
        job_start: data?.job_start ? getDateString(data.job_start) : null,
        job_end: data?.job_end ? getDateString(data.job_end) : null,
        owner_id: jobProfile?.currentOwner ? jobProfile?.currentOwner?.userId : null,
        department_id: jobProfile.departmentId,
        status: jobProfile.status,
        default_requirement_template_id: data.default_requirement_template_id
      };

      dispatch(updateJob(jobProfile.jobId, updatedData));
    }

    setIsEditing(!isEditing);
  };

  window.onbeforeunload = e => {
    if (isEditing && isDirty) {
      alertUser(e);
    }
  };

  const alertUser = e => {
    e.preventDefault();
    e.returnValue = '';
  };

  useEffect(() => {
    if (isDirty && isEditing) {
      window.addEventListener('beforeunload', alertUser);
    }

    return () => {
      window.removeEventListener('beforeunload', alertUser);
    };
    }, []); //eslint-disable-line

  const isArchived = useMemo(() => !!jobProfile?.archivedAt, [jobProfile]);

  return (
    <Box
      height="100%"
      layerStyle={isArchived ? 'archivedPanel' : 'panel'}
      minW="380px"
      mr={8}
      overflow="auto"
      p={6}
      w="380px"
    >
      <Prompt
        message="There are unsaved changes. Are you sure you want to exit?"
        when={isDirty && isEditing}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <JobInfoHeader isEditing={isEditing} />

        <Box minW="310px" textAlign="left">

          {renderDisplayOrForm()}

          <JobStats />

          <Attachments />
        </Box>
      </form>
    </Box>
  );
};

export default JobInfoPanel;
